export enum ProductType {
  Calkins = 'calkins',
  FountasPinell = 'fountas-pinell',
  Dtm = 'dtm',
  Flight = 'flight',
}
